import BaseAlertMessage from "./BaseAlertMessage.vue";

export * from "./BaseAlertMessage.vue";
export default BaseAlertMessage;
